import { useMemo } from 'react'
import type moment from 'moment'

import { filterRatePromotions } from 'lib/hotels/bedbankUtils'

export function useBedbankRoomRatePromotions(
  promotions: Array<App.BedbankPromotion> | undefined,
  checkInDate?: string,
  checkOutDate?: string,
  anytimeSearch = false,
) {
  return useMemo(() => filterRatePromotions(promotions ?? [], checkInDate, checkOutDate, anytimeSearch), [promotions, checkInDate, checkOutDate, anytimeSearch])
}

export function useBedbankPromotions(promotions: Array<App.BedbankPromotion>, checkinDate?: moment.Moment, checkoutDate?: moment.Moment) {
  return useMemo(() => {
    return !(checkinDate && checkoutDate) && promotions.length > 0 ? promotions : []
  }, [promotions, checkinDate, checkoutDate])
}

export function useBedbankSearchTilePromotions(promotions: Array<App.BedbankPromotion>, rate?: { id: string, promotionId?: string }, checkinDate?: string, checkoutDate?: string) {
  return useMemo<Array<App.BedbankPromotion>>(() => {
    if (rate) {
      const ratesPromo = filterRatePromotions(promotions, checkinDate, checkoutDate)
      const promo = ratesPromo[rate.promotionId ?? '']
      return promo ? [promo] : []
    }

    return promotions
  }, [promotions, rate, checkinDate, checkoutDate])
}
